import { render } from "./DataTable.vue?vue&type=template&id=3ac1f83b"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=3ac1f83b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ac1f83b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ac1f83b', __exports__)) {
    api.reload('3ac1f83b', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=3ac1f83b", () => {
    api.rerender('3ac1f83b', render)
  })

}


export default __exports__